export default __webpack_public_path__ + "static/media/expenses-screen.8a2576bd.png";